var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorInfoClientSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 50.75C32.4995 50.75 36.898 49.4157 40.6392 46.9159C44.3804 44.4161 47.2964 40.8631 49.0183 36.706C50.7401 32.549 51.1907 27.9748 50.3129 23.5617C49.435 19.1486 47.2683 15.095 44.0867 11.9133C40.905 8.73167 36.8514 6.56494 32.4383 5.68713C28.0252 4.80932 23.451 5.25984 19.2939 6.98174C15.1369 8.70363 11.5839 11.6196 9.08406 15.3608C6.58426 19.102 5.24999 23.5005 5.24999 28C5.25636 34.0317 7.65527 39.8146 11.9203 44.0796C16.1854 48.3447 21.9683 50.7436 28 50.75ZM28 8.74999C31.8073 8.74999 35.5291 9.87899 38.6947 11.9942C41.8604 14.1094 44.3277 17.1159 45.7847 20.6333C47.2417 24.1508 47.6229 28.0214 46.8801 31.7555C46.1373 35.4896 44.304 38.9196 41.6118 41.6118C38.9196 44.304 35.4896 46.1373 31.7555 46.8801C28.0213 47.6229 24.1508 47.2417 20.6333 45.7847C17.1159 44.3277 14.1094 41.8604 11.9942 38.6947C9.87898 35.5291 8.74999 31.8073 8.74999 28C8.75578 22.8964 10.7858 18.0034 14.3946 14.3946C18.0034 10.7858 22.8964 8.75578 28 8.74999Z",
    fill: "#CC0000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14219_11846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3682 38.5957C29.1966 38.5957 29.8682 37.9241 29.8682 37.0957C29.8682 36.2673 29.1966 35.5957 28.3682 35.5957C27.5397 35.5957 26.8682 36.2673 26.8682 37.0957C26.8682 37.9241 27.5397 38.5957 28.3682 38.5957Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3682 18.0957V31.0957",
    stroke: "#CC0000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14219_11846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(12.3682 12.0957)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorInfoClientSearch);
export default __webpack_public_path__ + "static/media/ErrorInfoClientSearch.eae139cfd042e946795d263d092f982a.svg";
export { ForwardRef as ReactComponent };